import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import SuperAdminLogin from "./superAdminLogin";
import SuperAdminTerms from "./superAdminTerms";
import SuperAdminRegister from "./superAdminRegister";
import ManageAdmin from "./manageAdmin";
import ManageOrganisations from "./manageOrganisations";
import ForgotPassword from "./forgotPassword";
import ResetTokenComponent from "./resetPassword";
import VerifySuperAdmin from "./verifySuperAdmin";
import ManageSuperAdmin from "./manageSuperAdmin";
import EditOrganisations from "./editOrg";
import {
  PortalAuthGuard,
  PortalNotFound,
  PortalPublicOnly,
} from "../_shared/routeGuards";

const SuperAdminRouter = () => {
  return (
    <Routes>
      <Route
        path="login"
        element={
          <PortalPublicOnly
            role="superadmin"
            homePath="/superadmin/manage-organisations"
          >
            <SuperAdminLogin />
          </PortalPublicOnly>
        }
      />
      <Route path="activate-account" element={<VerifySuperAdmin />} />
      <Route path="terms" element={<SuperAdminTerms />} />
      <Route path="register" element={<SuperAdminRegister />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
      <Route path="reset-token/:id" element={<ResetTokenComponent />} />

      <Route element={<PortalAuthGuard loginPath="/superadmin/login" role="superadmin" />}>
        <Route index element={<Navigate to="manage-organisations" replace />} />
        <Route path="manage-superadmin" element={<ManageSuperAdmin />} />
        <Route path="manage-admin" element={<ManageAdmin />} />
        <Route path="manage-organisations" element={<ManageOrganisations />} />
        <Route path="edit-organisation/:id" element={<EditOrganisations />} />
        <Route
          path="*"
          element={
            <PortalNotFound
              homePath="/superadmin/manage-organisations"
              portalName="superadmin"
            />
          }
        />
      </Route>
    </Routes>
  );
};

export default SuperAdminRouter;
